import { useSessionResume } from '../../hooks/shared/auth/useSessionResume'

interface Props {
  enabled: boolean
}

export default function SessionResumeWatcher({ enabled }: Props) {
  useSessionResume(enabled)
  return null
}
